/*
 * @Author: ken yang
 * @Date: 2022-09-13 14:25:14
 * @LastEditTime: 2022-09-28 18:48:15
 * @LastEditors: ken yang
 * @Description: 常量文件
 * @FilePath: /uexch_pc/src/utils/constant.js
 */
const PAGES = {
  pageNum: 1,
  pageSize: 10,
}

const UPLOAD = {
  size: 5
}

const LANGEN = 'us_en'
const LANGCN = 'zh_cn'
const LANGTW = 'zh_tw'
const LANGJA = 'ja_jp'

export {
  PAGES,
  UPLOAD,
  LANGEN,
  LANGCN,
  LANGTW,
  LANGJA,
}
